export const branding = {
    brandName: 'Guri dos Drones',
    brandNamePart1: 'Guri dos',
    brandNamePart2: 'Drones',
    primaryDomain: 'guridosdrones-web.pages.dev',
    colors: {
        // Cores principais baseadas em verde vibrante (inspirado em AGROMKT)
        primary: '#10b981', // Verde vibrante (emerald-500) - cor principal
        secondary: '#0f766e', // Dark teal (teal-700) - cor secundária
        accent: '#06b6d4', // Cyan (cyan-500) - cor complementar
        background: '#ffffff',
        surface: '#f8fafc', // slate-50 - mais suave
        text: '#0f172a', // slate-900 - mais escuro e profissional
        textMuted: '#64748b', // slate-500 - cinza profissional
        border: '#e2e8f0', // slate-200 - mais suave
        error: '#ef4444', // red-500 - vermelho mais suave
        warning: '#f59e0b', // amber-500
        success: '#10b981', // Verde alinhado com primary
    },
    typography: {
        fontFamily: {
            sans: ['Inter', 'system-ui', 'sans-serif'],
            serif: ['Georgia', 'serif'],
            mono: ['Fira Code', 'monospace'],
        },
        fontSize: {
            xs: '0.75rem',
            sm: '0.875rem',
            base: '1rem',
            lg: '1.125rem',
            xl: '1.25rem',
            '2xl': '1.5rem',
            '3xl': '1.875rem',
            '4xl': '2.25rem',
        },
    },
    spacing: {
        xs: '0.25rem',
        sm: '0.5rem',
        md: '1rem',
        lg: '1.5rem',
        xl: '2rem',
        '2xl': '3rem',
    },
    logos: {
        primary: '/assets/branding/logo-primary.svg',
        secondary: '/assets/branding/logo-secondary.svg',
        favicon: '/assets/branding/favicon.ico',
    },
    contact: {
        phone: '+55 (55) 99689-8432',
        whatsapp: 'https://wa.me/55996898432',
        address: {
            line1: 'Av. Engenheiro Ildefonso Simões Lopes, 1338 - B',
            line2: 'Três Vendas',
            city: 'Pelotas',
            state: 'RS',
            zip: '96060-290',
            country: 'BR',
        },
        hours: {
            weekdays: { start: '8h', end: '18h' },
            saturday: { start: '8h', end: '12h' },
        },
    },
    social: {
        instagram: 'https://www.instagram.com/guri_dos_drones/',
        whatsapp: 'https://wa.me/55996898432',
        youtube: 'https://www.youtube.com/@guridosdrones',
        tiktok: 'https://www.tiktok.com/@guridosdrones',
        linktree: 'https://linktr.ee/guridot10',
    },
};
//# sourceMappingURL=branding.js.map